import {Game} from "@game/game";
import {createContext, ReactElement, useContext, useEffect} from "react";
import {HostContext, HostServices} from "@components/host/HostProvider";

const GameInstance = new Game();
const GameContext = createContext(GameInstance);

interface IGameProvider {
    children: ReactElement | ReactElement []
}
function GameProvider({children}: IGameProvider) {
    const host = useContext(HostContext);

    useEffect(() => {
        if (! GameInstance.initialised && ! GameInstance.initialising) {
            GameInstance.initialise(HostServices).catch(error => {
                if (error.message === "Invalid session token") {
                    
                }
                console.error(error);
            });
        }
    }, []);
    return (
        <GameContext.Provider value={GameInstance}>
            <>
                {children}
            </>
        </GameContext.Provider>
    );
}

export {GameContext, GameProvider};